
var scrollEvent = null;
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate" // for vue-router 2.2+
]);

/**
 * 返回组件
 * @class
 * @version 1.0.0
 */
@Component
export default class PageBack extends Vue
{
    /**
     * 显示返回主页
     * @private
     * @returns boolean
     */
    @Prop({type: Boolean, default: true})
    private showHome: boolean;

    /**
     * 标题显示
     * @private
     * @returns string
     */
    @Prop({type: String, required: true})
    private title: string;

    /**
     * 名称
     * @private
     * @returns string
     */
    @Prop({type: String})
    private pathName: string;

    /**
     * 自定义方法
     * @private
     * @returns string
     */
    @Prop({type: Function})
    private customFn: any;

    /**
     * 背景颜色
     * @private
     * @returns string
     */
    @Prop({type: String, default: 'transparent'})
    private bgColor: string;

    /**
     * 滚动监听的情况下是否初始化显示标题
     * @private
     * @returns boolean
     */
    @Prop({type: Boolean, default: true})
    private scrollShowInitTitle: boolean;

    /**
     * 返回
     * @private
     * @returns void
     */
    private goBack(): void
    {
        if (this.isAi)
        {
            this.$router.go(-1);
            return;
        }
        if(this.customFn)
        {
            this.customFn();
        }
        else if(this.pathName)
        {
            this.$router.push({name: this.pathName});
        }
        else
        {
            this.$router.go(-1);
        }
    }

     /**
     * 跳转首页
     * @private
     * @returns void
     */
    private goHome(): void
    {
        this.$router.replace({name:"home"})
    }

    /**
     * 是否是ai跳转过来
     * @private
     * @returns boolean
     */
     private get isAi(): boolean
    {
        return (this.$route.query && this.$route.query.isAi == 'true') ? true : false;
    }

    private created() {
        this.$nextTick(() => {
            const pageBack = document.getElementById('page-back');
            const scrollElement = document.querySelector('.scroll-element');
            if (scrollElement && pageBack) {
                this.scrollFun(scrollElement, pageBack);
                scrollEvent = scrollElement.addEventListener('scroll', () => {
                    this.scrollFun(scrollElement, pageBack);
                });
            }
        })
    }

    private scrollFun(scrollElement, pageBack) {
        if (scrollElement.scrollTop > 60 && scrollElement.scrollTop < 120)
        {
            pageBack.style.backgroundColor = "rgba(255, 255, 255, 0.4)";
            
            pageBack.className = this.scrollShowInitTitle ? "page-back page-back-border-bottom page-back-show-title" : "page-back page-back-border-bottom";
        }
        else if (scrollElement.scrollTop > 120 && scrollElement.scrollTop < 200)
        {
            pageBack.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
        }
        else if (scrollElement.scrollTop > 200)
        {
            pageBack.style.backgroundColor = "rgba(255, 255, 255, 1)";
        }
        else if (scrollElement.scrollTop < 60)
        {
            pageBack.style.backgroundColor = "transparent";
            pageBack.className = "page-back";
            pageBack.className = this.scrollShowInitTitle ? "page-back page-back-show-title" : "page-back";
        }
    }
    private destroyed(){
        scrollEvent = null;
    }

}
